//const Turl="http://localhost:3000"
const Turl="https://mapi.bitbook.trade/bbk"
export {Turl}